package ui.widget

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.BoxScope
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.runtime.*
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.input.pointer.PointerEventPass
import androidx.compose.ui.input.pointer.pointerInput
import kotlinx.coroutines.delay
import kotlinx.coroutines.launch
import provider.LocalWindowProvider

class DialogState private constructor(
    visible: Boolean,
) {
    var visible by mutableStateOf(visible)

    companion object {
        @Composable
        fun remember(visible: Boolean = false, key: Any = Unit): DialogState = remember(key) {
            get(visible)
        }

        fun get(visible: Boolean = false): DialogState = DialogState(visible)
    }

    fun show() {
        visible = true
    }

    fun hide() {
        visible = false
    }
}

fun Modifier.blockTouch(): Modifier = this.pointerInput(Unit) {
    awaitPointerEventScope {
        // we should wait for all new pointer events
        while (true) {
            awaitPointerEvent(pass = PointerEventPass.Initial)
                .changes
                .filter { it.pressed }
                .forEach {
                    it.consume()
                }
        }
    }
}

@Composable
fun Dialog(
    state: DialogState,
    background: Color = Color.Transparent,
    onDismiss: () -> Unit = {},
    dismissOnTouchOutside: Boolean = true,
    body: @Composable BoxScope.() -> Unit
) {
    val windowProvider = LocalWindowProvider.current

    val scope = rememberCoroutineScope()

    windowProvider.attach {
        if (state.visible) {
            Box(
                Modifier.fillMaxSize()
                    .background(background)
            ) {
                Spacer(
                    Modifier.fillMaxSize()
                        .pointerInput(Unit) {
                            awaitPointerEventScope {
                                // we should wait for all new pointer events
                                while (true) {
                                    awaitPointerEvent(pass = PointerEventPass.Initial)
                                        .changes
                                        .filter { it.pressed }
                                        .forEach {
                                            it.consume()
                                            if (dismissOnTouchOutside) {
                                                if (state.visible) {
                                                    state.visible = false
                                                    scope.launch {
                                                        delay(100)
                                                        onDismiss()
                                                    }
                                                }
                                            }
                                        }

                                }
                            }
                        }
                )
                body()
            }
        }
    }
}
